import axios from "axios";
import { API_URL } from "../../const";

// Fetch Web Enquiry details
export const fetchWebEnquiry = (fetchData: JSON) => {
  const data = {
    FetchEnquiryListToken: fetchData,
  };

  const url = `${API_URL}fetchEnquiryDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};

// Export Web Enquiry details
export const exportWebEnquiry = (fetchData: JSON) => {
  const data = {
    CreateRequestReportToken: fetchData,
  };

  const url = `${API_URL}createRequestReport`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
